import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { IAuthUser } from '@app/core/interfaces/user';

export const AuthActions = createActionGroup({
  source: 'AUTH',
  events: {
    initialized: props<{ user: IAuthUser | null; error: string | null }>(),
    profileLoaded: props<{ user: IAuthUser }>(),
    sessionEnded: emptyProps(),
    logout: props<{ returnPath?: string }>(),
    setFavoriteUrl: props<{ favoriteUrl: string }>(),
  },
});
